import { blocks, type Blocks } from '@w/content-blocks'

export function serializeBlocksMd(items?: Blocks) {
  return items ? blocks.serialize(items) : ''
}
